import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';
import { loginGuard } from './core/guards/login-guard';
import { permissionGuard } from './core/guards/permission-guard';
import { PERMISSIONS } from './core/constants/permissions';
import { environment } from '../environments/environment';

// Dev-only preview route for the Availability Check section (design QA
// fixture, not wired to any backend call). Excluded from production builds.
const devRoutes: Routes = environment.production
  ? []
  : [
      {
        path: 'dev/availability',
        loadComponent: () =>
          import('./dev-availability-preview').then((m) => m.DevAvailabilityPreviewComponent),
      },
      {
        path: 'dev/event-details',
        loadComponent: () =>
          import('./dev-event-details-preview').then((m) => m.DevEventDetailsPreviewComponent),
      },
      {
        path: 'dev/message-box',
        loadComponent: () =>
          import('./dev-message-box-preview').then((m) => m.DevMessageBoxPreviewComponent),
      },
      {
        path: 'dev/chat-history',
        loadComponent: () =>
          import('./dev-chat-history-preview').then((m) => m.DevChatHistoryPreviewComponent),
      },
    ];

export const routes: Routes = [
  ...devRoutes,
  {
    path: 'login',
    loadChildren: () => import('./features/login/login.routes').then(m => m.loginRoutes),
    canActivate: [loginGuard]
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./features/reset-password/reset-password.routes').then(m => m.resetPasswordRoutes)
  },
  {
    path: '',
    loadComponent: () => import('./shared/layout/layout').then(m => m.Layout),
    canActivate: [authGuard],
    children: [
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes').then(m => m.usersRoutes),
        canActivate: [permissionGuard],
        data: { 
          requiredPermission: PERMISSIONS.VIEW_ALL_USERS,
          fallbackRoute: '/chat'
        }
      },
      {
        path: 'chat',
        loadChildren: () => import('./features/chat/chat.routes').then(m => m.chatRoutes)
      },
      {
        path: 'accounts',
        loadChildren: () => import('./features/accounts/accounts.routes').then(m => m.accountsRoutes),
        canActivate: [permissionGuard],
        data: { 
          requiredPermission: PERMISSIONS.VIEW_ACCOUNTS,
          fallbackRoute: '/chat'
        }
      },
      {
        path: 'api-clients',
        loadChildren: () => import('./features/api-clients/api-clients.routes').then(m => m.apiClientsRoutes),
        canActivate: [permissionGuard],
        data: { 
          requiredPermission: PERMISSIONS.VIEW_ALL_CREDENTIALS,
          fallbackRoute: '/chat'
        }
      },
      {
        path: '',
        redirectTo: '/chat',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
